module.exports = __webpack_public_path__ + "static/media/accessory_02.f374dd43.jpg";